<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">Purchase Order</h4>
					<button class="float-right btn btn-primary shadow mt-2"
					        v-on:click="formPurchaseOrderActive=!formPurchaseOrderActive">
						{{ dicts.label_tambah_no_po[dicts.lang] }}
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formPurchaseOrderActive">
						<div class="row p-3 mx-2 bg-white shadow">
							<div class="col-12 mb-3">
								<h4 class="my-0 py-0">{{ dicts.label_form_po_baru[dicts.lang] }}</h4>
								<hr>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.label_no_po[dicts.lang] }} <span
									style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded" v-model="newPurchaseOrder.no_po"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.label_currency[dicts.lang] }} <span
									style="color:red;">*</span></label>
								<!-- <input type="text" class="form-control w-100 rounded" v-model="newPurchaseOrder.currency" /> -->
								<smart-select name="currency" :options="currencyTypeOptions"
								              v-on:update="updateNewCurrency"></smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-inline">{{ dicts.label_nama_vendor[dicts.lang] }} <span
									style="color:red;">*</span></label>
								<div type="button" title="Tambah nama vendor" @click="openCreateVendorPopup"
								     class="d-inline ml-2"><span style="font-size:20px">+</span></div>
								<smart-search init :search-value="newvendorlabel" url="/api/master/seeker/vendor"
								              key-tag="vendor_name" usedefault :default-value="newvendorlabel"
								              :label-tag="['vendor_name']"
								              @update-direct="(label)=>newvendorlabel=label"
								              v-on:update="(data)=>smartSearchAddVendor(data)"></smart-search>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.label_tanggal[dicts.lang] }} <span
									style="color:red;">*</span></label>
								<b-form-datepicker today-button reset-button close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="example-datepicker" v-model="newPurchaseOrder.date_po" class="mb-2">
									{{ newPurchaseOrder.date_po }}
								</b-form-datepicker>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.label_tax[dicts.lang] }} <span
									style="color:red;">*</span></label>
								<smart-select name="ppn" :options="ppnTypeOptions"
								              v-on:update="updateNewPoPPN"></smart-select>
							</div>
							<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Type</label>
								<smart-select name="item_po" :options="statusTypeOptions" v-on:update="updateNewPoStatus"></smart-select>
							</div> -->

							<div class="col-12 mt-2">
								<div class="row m-2 border p-3 border-light shadow-sm rounded"
								     v-for="idx in totalNewhardware" v-bind:key="idx">
									<div class="col-12 mt-2 text-right">
										<b-button variant="danger" title="Delete" @click="deleteNewHardware(idx-1)">
											<b-icon icon="trash" class="text-danger"></b-icon>
										</b-button>
									</div>
									<div class="col-6">
										<label class="d-block">{{ dicts.label_perangkat[dicts.lang] }} <span
											style="color:red;">*</span></label>
										<!-- <input type="text"  class="form-control w-100 rounded" v-model="newPurchaseOrder.hardware.id[idx]" /> -->
										<!-- <smart-search url="/api/master/seeker/hardware" :addon="{item:newPurchaseOrder.item_po}" key-tag="hardware_name" v-on:update="(data)=>smartSearchUpdated(data,idx-1)"></smart-search> -->
										<smart-search init url="/api/master/seeker/hardware" key-tag="hardware_name"
										              @update-direct="(label)=>{newPurchaseOrder.hardware.labelHardware[idx-1]=label;$forceUpdate()}"
										              :search-value="newPurchaseOrder.hardware.labelHardware[idx-1]"
										              v-on:update="(data)=>smartSearchUpdated(data,idx-1)"></smart-search>
									</div>
									<div class="col-6"></div>
									<div class="col-3 mt-2">
										<label class="d-block">{{ dicts.label_jumlah[dicts.lang] }} <span
											style="color:red;">*</span></label>
										<input type="number" class="form-control w-100 rounded"
										       @input="calculateAmount(idx-1)"
										       v-model="newPurchaseOrder.hardware.qty[idx-1]"/>
									</div>
									<div class="col-3 mt-2">
										<label class="d-block">{{ dicts.label_harga_unit[dicts.lang] }}</label>
										<input type="number" class="form-control w-100 rounded"
										       @input="calculateAmount(idx-1)"
										       v-model="newPurchaseOrder.hardware.priceUnit[idx-1]"/>
									</div>
									<div class="col-3 mt-2">
										<label class="d-block">{{ dicts.label_tax[dicts.lang] }}</label>
										<div class="form-control w-100 rounded" readonly>
											{{ newPurchaseOrder.hardware.ppn[idx - 1] | numeral("0,0") }}
										</div>
									</div>
									<div class="col-3 mt-2">
										<label class="d-block">Total</label>
										<div class="form-control w-100 rounded" readonly>
											{{ newPurchaseOrder.hardware.amount[idx - 1] | numeral("0,0") }}
										</div>
									</div>
								</div>
								<button type="button" class="btn btn-light w-100 mt-2 shadow"
								        v-on:click="addNewHardware()">{{ dicts.label_button_add[dicts.lang] }}
								</button>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start"
								     v-if="newPurchaseOrderSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Menyimpan Purchase Order Baru.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start"
								     v-if="errorNewPurchaseOrder">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">Gagal Menyimpan Purchase Order Baru.</p>
										</div>
										<div v-for="err in errorPurchaseOrderList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start"
								     v-if="savingNewPurchaseOrder">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button" v-on:click="saveNewPO">
									{{ dicts.label_simpan[dicts.lang] }}
								</button>
							</div>
						</div>
					</div>
				</transition>


				<div class="col-12  my-2 py-0">
					<datatable :currentIdx="currentPage" :lang="dicts.lang" :datas="purchaseorders"
					           :structure="purchaseorderTableStructure" :init="loadData"
					           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
					           use-filter use-seeker seeker-url="/api/pemesanan/seeker/purchaseorder"
					           @refetch="(row)=>{rowLimit=row;getPurchaseOrders()}"
					           @searching="(val)=>!val.status?getPurchaseOrders():purchaseorders=val.data">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.label_no_po[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.no_po }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.label_currency[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.currency }}</b>
										</div>

									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.label_tanggal[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												obj.date_po | timeformat
											}}</b>
										</div>

									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.label_tax[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ obj.ppn == "yes" ? "Ya" : "Tidak" }}</b>
										</div>

									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.label_nama_vendor[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												obj.vendor.vendor_name
											}}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<b-button v-b-modal.modal-detail-po class="btn btn-primary mr-2 mb-1"
											          v-on:click="selectedDetail=index">
												<b-icon icon="eye"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-edit-po class="btn btn-info mr-2 mb-1"
											          v-on:click="selectedIdforEdit=index;dataEdit=Object.assign({},obj)"
											          v-if="['master_admin','admin'].includes(role)">
												<b-icon icon="pencil-square"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-delete
											          v-on:click="deleteId=obj.id;itemToDelete=obj"
											          class="btn btn-danger mb-1"
											          v-if="['master_admin','admin'].includes(role)">
												<b-icon icon="trash"></b-icon>
											</b-button>

										</div>
									</li>
								</ul>
							</td>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.no_po }}</td>
							<td v-if="!isMobile">{{ obj.currency }}</td>
							<td v-if="!isMobile">{{ obj.date_po | timeformat }}</td>
							<td v-if="!isMobile">{{ obj.ppn == "yes" ? "Ya" : "Tidak" }}</td>
							<!-- <td>{{ obj.item_po}}</td> -->
							<td v-if="!isMobile">{{ obj.vendor.vendor_name }}</td>
							<td v-if="!isMobile">
								<b-button v-b-modal.modal-detail-po title="View" class="btn btn-primary mr-2 mb-1"
								          v-on:click="selectedDetail=index">
									<b-icon icon="eye"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-edit-po title="Edit" class="btn btn-info mr-2 mb-1"
								          v-on:click="selectedIdforEdit=index;dataEdit=Object.assign({},obj)"
								          v-if="['master_admin','admin'].includes(role)">
									<b-icon icon="pencil-square"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-delete title="Delete"
								          v-on:click="deleteId=obj.id;itemToDelete=obj" class="btn btn-danger mb-1"
								          v-if="['master_admin','admin'].includes(role)">
									<b-icon icon="trash"></b-icon>
								</b-button>
							</td>
						</template>
					</datatable>
				</div>

				<b-modal no-close-on-esc content-class="m-0" id="modal-edit-po" title="Edit data" no-close-on-backdrop
				         size="lg" scrollable @hide="editModalClose" v-if="purchaseorders.length>0">
					<div class="row" v-if="purchaseorders[selectedIdforEdit]!=undefined">
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.label_no_po[dicts.lang] }}</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="purchaseorders[selectedIdforEdit].no_po"/>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.label_currency[dicts.lang] }}</label>
							<!-- <input type="text"  class="form-control w-100 rounded" v-model="purchaseorders[selectedIdforEdit].currency" /> -->
							<smart-select name="currency" :options="currencyTypeOptions" usedefault
							              :default-value="purchaseorders[selectedIdforEdit].currency"
							              v-on:update="(value)=>{purchaseorders[selectedIdforEdit].currency=value}"></smart-select>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.label_nama_vendor[dicts.lang] }}</label>
							<!-- <input type="text"  class="form-control w-100 rounded" v-model="purchaseorders[selectedIdforEdit].vendor_id" /> -->
							<smart-search init url="/api/master/seeker/vendor" usedefault
							              :default-value="purchaseorders[selectedIdforEdit].vendor.vendor_name"
							              key-tag="vendor_name"
							              v-on:update="(data)=>smartSearchUpdatedVendor(data)"></smart-search>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block" for="update-datepicker">{{ dicts.label_tanggal[dicts.lang] }}</label>
							<b-form-datepicker :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							                   id="update-datepicker"
							                   v-model="purchaseorders[selectedIdforEdit].date_po" class="mb-2">
								{{ purchaseorders[selectedIdforEdit].date_po }}
							</b-form-datepicker>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.label_tax[dicts.lang] }}</label>
							<smart-select name="ppn" :options="ppnTypeOptions" usedefault
							              :default-value="translatePPN(purchaseorders[selectedIdforEdit])"
							              v-on:update="updateEditPoPPN"></smart-select>
						</div>
						<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Type</label>
							<smart-select name="item_po" :options="statusTypeOptions" v-on:update="(value)=>{purchaseorders[selectedIdforEdit].item_po=value}"></smart-select>
						</div> -->
						<div class="col-12 mt-3">
							<div class="w-100 align-items-center justify-content-start" v-if="updating">
								<div class="alert alert-secondary" role="alert">
									Menyimpan data, tunggu sebentar.
								</div>
							</div>
						</div>
						<div class="col-12 mt-3">
							<div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
								<div class="alert alert-success" role="alert">
									Berhasil Update Data Purchase Order.
								</div>
							</div>
						</div>
						<div class="col-12 mt-3">
							<div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
								<div class="alert alert-danger" role="alert">
									Gagal update Purchase Order.
								</div>
							</div>
						</div>
						<div class="col-12 text-right">
							<button class="btn btn-info" v-on:click="updatePurchaseOrder(-1)">
								{{ dicts.label_simpan[dicts.lang] }}
							</button>
						</div>
					</div>

					<div class="row mt-3 pb-1" v-if="purchaseorders[selectedIdforEdit].metadata!=null">
						<div class="col-12">
							<hr>
						</div>
						<div class="col-12">
							<h4>Detail Purchase Order</h4>
						</div>
						<div class="col-12">
							<div class="row" v-for="(metadata,index) in purchaseorders[selectedIdforEdit].metadata"
							     v-bind:key="'metadata'+metadata.id">

								<div class="col-12 col-md-6 col-lg-12 mt-2">
									<label class="d-block">{{ dicts.label_perangkat[dicts.lang] }}</label>
									<!-- <input type="text"  class="form-control w-100 rounded"  v-model="purchaseorders[selectedIdforEdit].metadata[0].hardware.hardware_name" /> -->
									<smart-search init url="/api/master/seeker/hardware" :usedefault="true"
									              :default-value="metadata.hardware!=null?metadata.hardware.hardware_name:''"
									              key-tag="hardware_name" :label-tag="['hardware_name']"
									              v-on:update="(data)=>smartSearchUpdatedEdit(data)"></smart-search>
								</div>
								<div class="col-12 col-md-6 col-lg-3 mt-2">
									<label class="d-block">{{ dicts.label_jumlah[dicts.lang] }}</label>
									<input type="text" class="form-control w-100 rounded"
									       @input="calculateAmountEdit(index)" v-model="metadata.total_qty"/>
								</div>
								<div class="col-12 col-md-6 col-lg-3 mt-2">
									<label class="d-block">{{ dicts.label_harga_unit[dicts.lang] }}</label>
									<input type="text" class="form-control w-100 rounded"
									       @input="calculateAmountEdit(index)" v-model="metadata.unit_price"/>
								</div>
								<div class="col-12 col-md-6 col-lg-3 mt-2">
									<label class="d-block">{{ dicts.label_tax[dicts.lang] }}</label>
									<div class="form-control w-100 rounded" readonly>{{
											(purchaseorders[selectedIdforEdit].ppn != "no" ? (parseInt(metadata.qty) * parseInt(
												metadata.unit_price) * (purchaseorders[selectedIdforEdit].ppn_number/100)) : 0) | numeral("0,0")
										}}
									</div>
								</div>
								<div class="col-12 col-md-6 col-lg-3 mt-2">
									<label class="d-block">Total</label>
									<div class="form-control w-100 rounded" readonly>
										{{ metadata.amount | numeral("0,0") }}
									</div>
								</div>
								<div class="col-12 mt-3">
									<div class="w-100 align-items-center justify-content-start"
									     v-if="updating || (updatingDetail && (metaEditIndex==index))">
										<div class="alert alert-secondary" role="alert">
											Menyimpan data, tunggu sebentar.
										</div>
									</div>
								</div>
								<div class="col-12 mt-3">
									<div class="w-100 align-items-center justify-content-start"
									     v-if="updateSavedDetail && (metaEditIndex==index)">
										<div class="alert alert-success" role="alert">
											Berhasil Update Data Purchase Order.
										</div>
									</div>
								</div>
								<div class="col-12 mt-3">
									<div class="w-100 align-items-center justify-content-start"
									     v-if="errorUpdateDetail && (metaEditIndex==index)">
										<div class="alert alert-success" role="alert">
											Gagal update Purchase Order.
										</div>
									</div>
								</div>
								<div class="col-12 text-right">
									<button class="btn btn-info" v-show="!updating"
									        v-on:click="updatePurchaseOrderDetail(index)">
										{{ dicts.label_simpan[dicts.lang] }}
									</button>
								</div>

								<div class="col-12">
									<hr/>
								</div>
							</div>

						</div>
					</div>

					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<!-- <button class="btn btn-danger mr-2" v-on:click="deleteData">Ya, hapus</button> -->
							<b-button class="btn btn-secondary"
							          @click="(!deleteState)?$bvModal.hide('modal-edit-po'):''">Tutup
							</b-button>
						</div>
					</template>
				</b-modal>

				<b-modal no-close-on-esc content-class="m-0" id="modal-detail-po" size="lg" title="Detail data"
				         scrollable no-close-on-backdrop @hide="detailModalClose">
					<b-container fluid v-if="!loadData&&purchaseorders.length>0">
						<b-row class="pt-1" v-if="purchaseorders[selectedDetail]!=undefined">
							<b-col cols="12">
								<table v-if="purchaseorders.length>0" rules="rows" class="table w-100">
									<tr>
										<th class="px-3">{{ dicts.label_no_po[dicts.lang] }}</th>
										<th class="px-3">{{ dicts.label_currency[dicts.lang] }}</th>
										<th class="px-3">{{ dicts.label_nama_vendor[dicts.lang] }}</th>
										<th class="px-3">{{ dicts.label_tanggal[dicts.lang] }}</th>
										<th class="px-3">{{ dicts.label_tax[dicts.lang] }}</th>
										<!-- <th class="px-3">Type</th> -->
									</tr>
									<tr>
										<td class="">{{ purchaseorders[selectedDetail].no_po }}</td>
										<td class="">{{ purchaseorders[selectedDetail].currency }}</td>
										<td class="">
											{{
												purchaseorders[selectedDetail].vendor != null ? purchaseorders[selectedDetail].vendor.vendor_name : "-"
											}}
										</td>
										<td class="">{{ purchaseorders[selectedDetail].date_po | timeformat }}</td>
										<td class="">{{ translatePPN(purchaseorders[selectedDetail]) }}</td>
										<!-- <td class="">{{purchaseorders[selectedDetail].item_po}}</td> -->
									</tr>
									<tr>
										<th class="perangkat" colspan="5">{{ dicts.label_perangkat[dicts.lang] }}</th>
									</tr>
									<tr>
										<td class="" colspan="5">

											<!-- <b-container fluid v-for="meta in purchaseorders[selectedDetail].metadata" :key="meta" class="p-3 shadow-sm">
													<b-row>
														<b-col class="px-3 mb-3" cols="12"><div class="perangkat rounded w-100 px-3 bg-secondary text-white"><b style="font-size:14pt">{{meta.hardware!=null&&meta.hardware.hardware_name!=null?meta.hardware.hardware_name:'-'}}</b></div></b-col>
													</b-row>
													<b-row>
														<b-col class="px-3"><b>Kode Barang</b></b-col>
														<b-col class="px-3"><b>Jumlah</b></b-col>
														<b-col class="px-3"><b>Harga</b></b-col>
														<b-col class="px-3"><b>PPN</b></b-col>
														<b-col class="px-3"><b>Total</b></b-col>
													</b-row>
													<b-row md="6" lg="4">
														<b-col class="px-3">{{meta.hardware!=null&&meta.hardware.part_number?meta.hardware.part_number:'-'}}</b-col>
														<b-col class="px-3">{{meta.total_qty}}</b-col>
														<b-col class="px-3">{{meta.unit_price | numeral('0,0')}}</b-col>
														<b-col class="px-3">{{purchaseorders[selectedDetail].ppn=="yes"?(parseInt(meta.total_qty)*parseInt(meta.unit_price)/10):0 | numeral('0,0')}}</b-col>
														<b-col class="px-3">{{meta.amount| numeral('0,0')}}</b-col>
													</b-row>

											</b-container> -->
											<table class="table w-100 shadow-sm rounded"
											       v-for="meta in purchaseorders[selectedDetail].metadata" :key="meta">
												<tr>
													<th class="bg-secondary text-white text-left" colspan="5"><h5
														class="font-weight-bold">
														{{
															meta.hardware != null && meta.hardware.hardware_name != null ? meta.hardware.hardware_name : "-"
														}}</h5>
													</th>
												</tr>
												<tr>
													<th>{{ dicts.label_kode_barang[dicts.lang] }}</th>
													<th>{{ dicts.label_jumlah[dicts.lang] }}</th>
													<th>{{ dicts.label_harga_unit[dicts.lang] }}</th>
													<th>{{ dicts.label_tax[dicts.lang] }}</th>
													<th>Total</th>
												</tr>
												<tr>
													<td>
														{{
															meta.hardware != null && meta.hardware.part_number ? meta.hardware.part_number : "-"
														}}
													</td>
													<td>{{ meta.total_qty }}</td>
													<td>{{ meta.unit_price | numeral("0,0") }}</td>
													<td>{{
															purchaseorders[selectedDetail].ppn != "no" ? (parseInt(meta.total_qty) * parseInt(
																meta.unit_price) * (purchaseorders[selectedDetail].ppn/100)) : 0 | numeral("0,0")
														}}
													</td>
													<td>{{ meta.amount| numeral("0,0") }}</td>
												</tr>
											</table>
										</td>
									</tr>


								</table>
							</b-col>
							<!-- <b-col cols="12" class="my-3">
								<h4>Detail Tittle:</h4>
								<ul v-if="purchaseorders.length>0">
									<li>Nomor PO: {{purchaseorders[selectedDetail].no_po}}</li>
									<li>Vendor: {{purchaseorders[selectedDetail].vendor!=null?purchaseorders[selectedToDelete].vendor.vendor_name:'-'}}</li>
									<li>Tanggal: {{purchaseorders[selectedDetail].date_po}}</li>
									<li>PPN: {{purchaseorders[selectedDetail].ppn}}</li>
									<li>Type: {{purchaseorders[selectedDetail].item_po}}</li>
								</ul>
								<h4>Purchase order detail</h4>
								<ul>
									<li v-for="meta in purchaseorders[selectedDetail].metadata" :key="meta">{{meta.hardware.hardware_name}}</li>
								</ul>
							</b-col> -->
							<b-col cols="12" class="my-3 text-right" v-if="deleteState">
								<div class="d-flex align-items-center justify-content-start">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
								</div>
							</b-col>
							<div class="col-12 mt-3" v-if="deleted">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-success" role="alert">
										Berhasil menghapus data klien.
									</div>
								</div>
							</div>
							<div class="col-12 mt-3" v-if="deleteFail">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-danger" role="alert">
										Gagal menghapus data klien.
									</div>
								</div>
							</div>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<!-- <button class="btn btn-danger mr-2" v-on:click="deleteData">Ya, hapus</button> -->
							<b-button class="btn btn-secondary"
							          @click="(!deleteState)?$bvModal.hide('modal-detail-po'):''">Tutup
							</b-button>
						</div>
					</template>
				</b-modal>

				<modal-delete url="/api/pemesanan/purchaseorder/" @read="()=>{console.log('modal ready')}"
				              @result="deleteResult" :targetid="deleteId">
					{{ dicts.label_desc_delete[dicts.lang] }} :<br>
					<ul>
						<li>{{ dicts.label_no_po[dicts.lang] }}: {{ itemToDelete.no_po }}</li>
						<li>{{ dicts.label_tipe[dicts.lang] }}:
							{{ itemToDelete.metadata != null ? itemToDelete.metadata[0].hardware.item : "-" }}
						</li>
					</ul>
				</modal-delete>

				<!-- <b-modal no-close-on-esc  content-class="m-0"  id="modal-delete-po" title="Konfirmasi hapus data" scrollable no-close-on-backdrop @hide="deleteModalClose">
					<b-container fluid v-if="!loadData">
						<b-row class="pt-1">
						<b-col cols="12" class="my-3">
							<h4>Apakah yakin mau menghapus data dengan detail berikut:</h4>
							<ul v-if="purchaseorders.length>0">
								<li>Nomor PO: {{purchaseorders[selectedToDelete].no_po}}</li>
								<li>Vendor: {{purchaseorders[selectedToDelete].vendor!=null?purchaseorders[selectedToDelete].vendor.vendor_name:'-'}}</li>
							</ul>
						</b-col>
						<b-col cols="12" class="my-3 text-right"  v-if="deleteState">
							<div class="d-flex align-items-center justify-content-start">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
								</div>
							</b-col>
							<div class="col-12 mt-3"  v-if="deleted">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-success" role="alert">
										Berhasil menghapus data klien.
									</div>
								</div>
							</div>
							<div class="col-12 mt-3"  v-if="deleteFail">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-danger" role="alert">
										Gagal menghapus data klien.
									</div>
								</div>
							</div>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
						<hr>
						<button class="btn btn-danger mr-2" v-on:click="deleteData">Ya, hapus</button>
						<b-button class="btn btn-secondary" @click="(!deleteState)?$bvModal.hide('modal-delete-po'):''">Tutup</b-button>
						</div>
					</template>
				</b-modal> -->

			</div>
		</div>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import {EventBus} from "../../eventbus";
import * as axios from "axios";
import moment from "moment";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import SmartSearch from "../../components/SmartSearch.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"smart-search": SmartSearch,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			base_ppn:10,
			currentPage: 1,
			perPage: null,
			role: "",
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			isMobile: false,
			errorNewUserList: [],
			newvendorlabel: "",
			//step 1 edit
			dataEdit: null,
			itemToDelete: {},
			deleteId: 0,
			purchaseorders: [],
			searchValue: "",
			loadData: true,
			savingNewPurchaseOrder: false,
			updating: false,
			updatingDetail: false,
			updateSaved: false,
			updateSavedDetail: false,
			deleted: false,
			deleteFail: false,
			deleteState: false,
			selectedToDelete: 0,
			errorNewPurchaseOrder: false,
			errorUpdate: false,
			errorUpdateDetail: false,
			errorPurchaseOrderList: [],
			existingClientResult: [],
			newPurchaseOrderSaved: false,
			selectedIdforEdit: 0,
			metaEditIndex: 0,
			selectedDetail: 0,
			selectedTab: 0,
			totalNewhardware: 0,
			totalNo: 0,
			newPurchaseOrder: {
				no_po: "",
				currency: "IDR",
				vendor_id: "",
				date_po: "",
				ppn: "no",
				item_po: "antena",
				hardware: {
					id: [],
					qty: [],
					amount: [],
					ppn: [],
					priceUnit: [],
					labelHardware: []
				}
			},
			formPurchaseOrderActive: false,
			purchaseorderTableStructure: [
				{label: "No", key: null},
				{
					label: {
						id: "Nomor PO",
						en: "PO number"
					},
					key: null
				},
				{
					label: {
						id: "Mata uang",
						en: "Currency"
					},
					key: null
				},
				{
					label: {
						id: "Tanggal pesanan",
						en: "Order date"
					},
					key: null
				},
				{
					label: {
						id: "PPN",
						en: "Tax"
					},
					key: null
				},
				{
					label: {
						id: "Nama vendor",
						en: "Vendor name"
					},
					key: null
				},
				{
					label: {
						id: "Tindakan",
						en: "Action"
					},
					key: null
				}
			],
			dicts: {
				lang: "id",
				label_tambah_no_po: {
					id: "Tambah purchase order baru",
					en: "Add purchase order"
				},
				label_no_po: {
					id: "Nomor PO",
					en: "PO Number"
				},
				label_currency: {
					id: "Mata uang",
					en: "Currency"
				},
				label_nama_vendor: {
					id: "Nama vendor",
					en: "Vendor name"
				},
				label_tanggal: {
					id: "Tanggal pesanan",
					en: "Order date"
				},
				label_tax: {
					id: "PPN",
					en: "Tax"
				},
				label_form_po_baru: {
					id: "Form purchase order",
					en: "New purchase order form"
				},
				label_button_add: {
					id: "Tambah purchase order detail",
					en: "Add purchase order detail"
				},
				label_simpan: {
					id: "Simpan",
					en: "Submit"
				},
				label_perangkat: {
					id: "Nama perangkat",
					en: "Hardware name"
				},
				label_jumlah: {
					id: "Jumlah",
					en: "Quantity"
				},
				label_harga_unit: {
					id: "Harga unit",
					en: "Unit price"
				},
				label_kode_barang: {
					id: "Kode barang",
					en: "Part number"
				},
				label_desc_delete: {
					id: "Yakin mau menghapus data dengan detail berikut",
					en: "You are sure you want to delete data with the following details"
				},
				label_tipe: {
					id: "Tipe",
					en: "Type"
				}
			},
			ppnTypeOptions: [
				// {label: "Ya", value: "yes"},
				{label: "Tidak", value: "no"}
			],
			currencyTypeOptions: [
				{label: "IDR", value: "IDR"},
				{label: "USD", value: "USD"}
			]
			// statusTypeOptions:[
			//     {label:'Antena',value:'antena'},
			//     {label:'JB',value:'jb'},
			// ]
		};
	},
	created() {
		this.role = localStorage.getItem("role");
		this.newvendorlabel = "";
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		this.getPurchaseOrders();
		//window.onstorage = this.storageEvent()
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			// console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		this.dicts.lang = localStorage.getItem("lang");
		EventBus.$on("lang", () => {
			console.log("changing PO lang");
			this.dicts.lang = localStorage.getItem("lang");
		});
		EventBus.$on("datavendor", (vendor) => {
			console.log(vendor);
		});
		EventBus.$on("newvendor", (vendor) => {
			console.log("retrieving from popup");
			console.log(vendor);
			this.newPurchaseOrder.vendor_id = vendor.id;
			this.newvendorlabel = vendor.vendor_name;
		});
        this.getSetPpn();
	},
	methods: {
        getSetPpn(){
          axios.get(this.$baseUrl + "/api/setting?key=ppn", {
            "headers": {
              "Authorization": "Bearer " + localStorage.getItem("accessToken")
            }
          }).then((result) => {
            console.log(result);
            this.base_ppn = result.data.value;
            result.data.forEach((data)=>{
            	this.ppnTypeOptions.push({label:data.value+' %',value:data.value})
            })
            console.log(this.base_ppn);
          }).catch((err) => {
            //check if token fail
          });
        },
		updateNewCurrency(data) {
			this.newPurchaseOrder.currency = data;
		},
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = myParams;
			var newUrl = this.$baseUrl + "/api/pemesanan/purchaseorder?limit=" + this.rowLimit + "&page=" + myParams;
			this.getPurchaseOrders(newUrl);
			// this.getPurchaseOrders(isNext?this.nextUrl:this.prevUrl)
		},
		// storageEvent(){
		//     var temp = JSON.parse(localStorage.getItem('datavendor'));
		//     console.log(temp)
		//     if(temp!=null){
		//         this.newPurchaseOrder.vendor_id=temp.data.id
		//         this.newvendorlabel=temp.data.vendor_name
		//         localStorage.removeItem('datavendor')
		//     }
		// },
		resetNewPO() {
			this.newvendorlabel = "";
			this.newPurchaseOrder = {
				no_po: "",
				currency: "IDR",
				vendor_id: "",
				date_po: "",
				ppn: "yes",
				item_po: "antena",
				hardware: {
					id: [],
					qty: [],
					amount: [],
					ppn: [],
					priceUnit: [],
					labelHardware: []
				}
			};
		},
		openCreateVendorPopup() {
			window.open(
				"/#/admin/datamaster/create-popup-vendor",
				"CreateVendor",
				"toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=800"
			);
		},
		translatePPN(data) {
			var label = "";
			switch (data.ppn) {
				// case "yes":
				// 	label = "Ya";
				// 	break;
				case "no":
					label = "Tidak";
					break;
				default:
					label = data.ppn_number+'%';
					break;
			}
			return label;
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getPurchaseOrders();
			}
		},
		getPurchaseOrders(url = (this.$baseUrl + "/api/pemesanan/purchaseorder?limit=" + this.rowLimit)) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.purchaseorders = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		calculateAmount(id) {
			console.log("calculating at index" + id);
			//force update remove leading zero
			this.newPurchaseOrder.hardware.qty[id] = parseInt(this.newPurchaseOrder.hardware.qty[id]);
			this.newPurchaseOrder.hardware.priceUnit[id] = parseInt(this.newPurchaseOrder.hardware.priceUnit[id]);

			if (this.newPurchaseOrder.hardware.qty[id] > 0 && this.newPurchaseOrder.hardware.priceUnit[id] > 0) {
				this.newPurchaseOrder.hardware.amount[id] = parseInt(this.newPurchaseOrder.hardware.priceUnit[id]) * parseInt(
					this.newPurchaseOrder.hardware.qty[id]);
				if (this.newPurchaseOrder.ppn != "no") {
					console.log("with ppn");
					this.newPurchaseOrder.hardware.ppn[id] = parseInt(this.newPurchaseOrder.hardware.amount[id]) * (this.newPurchaseOrder.ppn/100);
					this.newPurchaseOrder.hardware.amount[id] = this.newPurchaseOrder.hardware.ppn[id] + this.newPurchaseOrder.hardware.amount[id];
				} else {
					console.log("no ppn");
					this.newPurchaseOrder.hardware.ppn[id] = 0;
					console.log(this.newPurchaseOrder.hardware.ppn[id]);
				}
			} else {
				this.newPurchaseOrder.hardware.amount[id] = 0;
				this.newPurchaseOrder.hardware.ppn[id] = 0;
			}
			console.log(this.newPurchaseOrder.hardware.ppn[id]);
			this.$forceUpdate();
		},
		calculateAmountEdit(index) {
			console.log("calculating");
			if (this.purchaseorders[this.selectedIdforEdit].metadata[index].total_qty > 0 && this.purchaseorders[this.selectedIdforEdit].metadata[index].unit_price > 0) {
				var amount = parseInt(this.purchaseorders[this.selectedIdforEdit].metadata[index].total_qty) * parseInt(
					this.purchaseorders[this.selectedIdforEdit].metadata[index].unit_price);
				if (this.purchaseorders[this.selectedIdforEdit].ppn != "no") {
					console.log("edit with ppn");
					var ppn = amount * (this.purchaseorders[this.selectedIdforEdit].ppn_number/100);
					this.purchaseorders[this.selectedIdforEdit].metadata[index].amount = ppn + amount;

					// this.purchaseorders[this.selectedIdforEdit].metadata[index].amount = parseInt(this.purchaseorders[this.selectedIdforEdit].metadata[index].unit_price) * parseInt(this.purchaseorders[this.selectedIdforEdit].metadata[index].qty);
				} else {
					console.log("edit no ppn");
					this.purchaseorders[this.selectedIdforEdit].metadata[index].amount = amount;
				}
			} else {
				this.purchaseorders[this.selectedIdforEdit].metadata[index].amount = 0;
				this.purchaseorders[this.selectedIdforEdit].metadata[index].ppn = 0;
			}
			this.$forceUpdate();
		},
		updatePurchaseOrder(index) {
			this.updating = true;
			this.errorUpdate = false;
			axios.put(
				this.$baseUrl + "/api/pemesanan/purchaseorder/" + this.purchaseorders[this.selectedIdforEdit].id,
				this.purchaseorders[this.selectedIdforEdit],
				{
					// {
					// no_po:this.purchaseorders[this.selectedIdforEdit].no_po,
					// vendor_id:this.purchaseorders[this.selectedIdforEdit].vendor_id,
					// date_po:this.purchaseorders[this.selectedIdforEdit].date_po,
					// ppn:this.purchaseorders[this.selectedIdforEdit].ppn,
					//  item_po:this.purchaseorders[this.selectedIdforEdit].item_po,
					// },
					headers: {
						"Authorization": "Bearer " + localStorage.getItem("accessToken")
					}
				}
			).then((result) => {
				if (result.status = 200) {
					this.updating = false;
					this.updateSaved = true;
					this.getPurchaseOrders();
					this.dataEdit = this.purchaseorders[this.selectedIdforEdit];
					setTimeout(() => {
						this.updateSaved = false;
						this.$bvModal.hide("modal-edit-po");
					}, 1000);
				}
				console.log(result);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updating = false;
				this.errorUpdate = true;
				console.log(err.response);
			});
		},
		updatePurchaseOrderDetail(index) {
			console.log("updating data");
			console.log(this.purchaseorders[this.selectedIdforEdit].metadata[index]);
			this.updatingDetail = true;
			this.errorUpdateDetail = false;
			this.metaEditIndex = index;
			axios.put(
				this.$baseUrl + "/api/pemesanan/purchaseordermetadata/" + this.purchaseorders[this.selectedIdforEdit].metadata[index].id,
				this.purchaseorders[this.selectedIdforEdit].metadata[index],
				{
					headers: {
						"Authorization": "Bearer " + localStorage.getItem("accessToken")
					}
				}
			).then((result) => {
				if (result.status = 200) {
					this.updatingDetail = false;
					this.updateSavedDetail = true;
					this.getPurchaseOrders();
					setTimeout(() => {
						this.updateSavedDetail = false;
						this.$bvModal.hide("modal-edit-po");
					}, 1000);
				}
				console.log(result);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updatingDetail = false;
				this.errorUpdateDetail = true;
				console.log(err.response);
			});
		},
		updateNewPoPPN(data) {
			this.newPurchaseOrder.ppn = data;
			for (var x = 0; x < this.newPurchaseOrder.hardware.ppn.length; x++) {

				this.calculateAmount(x);

			}
		},
		updateEditPoPPN(value) {
			// console.clear();
			this.purchaseorders[this.selectedIdforEdit].ppn_number = (value != "no" ? value : 0);
			this.purchaseorders[this.selectedIdforEdit].ppn = (value != "no" ? "yes" : "no");
			
			console.log(this.purchaseorders[this.selectedIdforEdit]);
			for (var x = 0; x < this.purchaseorders[this.selectedIdforEdit].metadata.length; x++) {

				this.calculateAmountEdit(x);

			}
		},
		updateNewPoStatus(data) {
			this.newPurchaseOrder.item_po = data;
		},
		// saveNewPurchaseOrder(){
		//     this.savingNewPurchaseOrder=true
		//     this.errorNewPurchaseOrder=false
		//     console.log(this.newPurchaseOrder)
		//     if(
		//         this.newPurchaseOrder.no_po!='' &&
		//         this.newPurchaseOrder.vendor_id!='' &&
		//         this.newPurchaseOrder.date_po &&
		//         this.newPurchaseOrder.ppn!='' &&
		//         this.newPurchaseOrder.item_po
		//         ){
		//         axios.post(this.$baseUrl+'/api/pemesanan/purchaseorder',
		//         {
		//             no_po:this.newPurchaseOrder.no_po,
		//             vendor_id:this.newPurchaseOrder.vendor_id,
		//             date_po:this.newPurchaseOrder.date_po,
		//             ppn:this.newPurchaseOrder.ppn,
		//             item_po:this.newPurchaseOrder.item_po
		//         },
		//         {
		//             'headers':
		//             {
		//                 'Authorization':'Bearer '+localStorage.getItem('accessToken')
		//             }
		//         }).then((result)=>{
		//             //console.log(result)
		//             if(result.data.create){
		//                 this.getPurchaseOrders();
		//             }
		//             this.newPurchaseOrder.no_po='',
		//             this.newPurchaseOrder.vendor_id='',
		//             this.newPurchaseOrder.date_po='',
		//             this.newPurchaseOrder.ppnType='yes',
		//             this.newPurchaseOrder.statusType='yes',
		//             this.savingNewPurchaseOrder=false
		//             this.newPurchaseOrderSaved=true

		//             setTimeout(() => {
		//                 this.newPurchaseOrderSaved=false
		//                 this.formPurchaseOrderActive=false
		//             }, 1500);

		//         }).catch((err)=>{
		//check if token fail
		//   if(err.response && err.response.status==401){
		//     localStorage.removeItem('accessToken')
		//   this.$router.push('/login')
		//   }
		//             console.log(err.response)
		//             this.errorPurchaseOrderList=[]
		//             this.errorPurchaseOrderList=Object.values(err.response.data.errors)
		//             console.log(this.errorPurchaseOrderList)
		//             this.errorNewPurchaseOrder=true
		//             this.savingNewPurchaseOrder=false
		//         })
		//     }
		// },
		addNewHardware() {
			//console.log(this.newPurchaseOrder.hardware)
			this.newPurchaseOrder.hardware.priceUnit.push(0);
			this.newPurchaseOrder.hardware.id.push(0);
			this.newPurchaseOrder.hardware.qty.push(0);
			this.newPurchaseOrder.hardware.amount.push(0);
			this.newPurchaseOrder.hardware.labelHardware.push("");
			this.totalNewhardware++;
			console.log(this.newPurchaseOrder.hardware);
		},
		deleteNewHardware(index) {
			this.newPurchaseOrder.hardware.priceUnit.splice(index, 1);
			this.newPurchaseOrder.hardware.id.splice(index, 1);
			this.newPurchaseOrder.hardware.qty.splice(index, 1);
			this.newPurchaseOrder.hardware.amount.splice(index, 1);
			this.newPurchaseOrder.hardware.labelHardware.splice(index, 1);
			this.totalNewhardware--;
		},
		deleteItem(index) {
			console.log("button delete untuk user id: " + index);
		},
		updateUserRoleValue(newValue) {
			this.newPurchaseOrder.role = newValue;
		},
		setNewClientId(newId) {
			this.newPurchaseOrder.clientId = newId;
			console.log(this.newPurchaseOrder.clientId);
		},
		updateNewHardwareItemType(value) {
			this.newPurchaseOrder.itemType = value;
		},
		smartSearchUpdated(data, index) {
			this.newPurchaseOrder.hardware.id[index] = data.id;
			console.log(this.newPurchaseOrder.hardware.id[index]);
		},
		smartSearchUpdatedEdit(data) {
			this.purchaseorders[this.selectedIdforEdit].metadata[0].hardware_id = data.id;
			console.log(this.purchaseorders[this.selectedIdforEdit]);
		},
		smartSearchUpdatedVendor(data) {
			// console.clear()
			// console.log("new client id:" + this.purchaseorders[selectedIdforEdit].vendor_id)
			this.purchaseorders[this.selectedIdforEdit].vendor_id = data.id;
		},
		smartSearchAddVendor(data) {
			this.newPurchaseOrder.vendor_id = data.id;

		},
		saveNewPO() {
			//if(this.newPurchaseOrder.no_po!=''){}
			// console.log(this.newPurchaseOrderSaved)
			// return;
			this.savingNewPurchaseOrder = true;
			this.errorNewPurchaseOrder = false;
			if (
				this.newPurchaseOrder.no_po != "" &&
				this.newPurchaseOrder.currency != "" &&
				this.newPurchaseOrder.date_po != "" &&
				this.newPurchaseOrder.hardware.id != "" &&
				this.newPurchaseOrder.hardware.qty != ""
			) {
				axios.post(this.$baseUrl + "/api/pemesanan/purchaseorder", {
					           no_po: this.newPurchaseOrder.no_po,
					           currency: this.newPurchaseOrder.currency,
					           vendor_id: this.newPurchaseOrder.vendor_id,
					           date_po: this.newPurchaseOrder.date_po,
					           // 'item_po':this.newPurchaseOrder.item_po,
					           ppn: this.newPurchaseOrder.ppn,
								ppn : (this.newPurchaseOrder.ppn != "no" ? "yes" : "no"),
								ppn_number  : (this.newPurchaseOrder.ppn != "no" ? this.newPurchaseOrder.ppn : 0),
					           hardware_id: this.newPurchaseOrder.hardware.id,
					           qty: this.newPurchaseOrder.hardware.qty,
					           amount: this.newPurchaseOrder.hardware.amount,
					           price_unit: this.newPurchaseOrder.hardware.priceUnit
				           },
				           {
					           "headers":
						           {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
				           }
				).then((result) => {
					console.log(result);
					this.resetNewPO();
					this.savingNewPurchaseOrder = false;
					this.newPurchaseOrderSaved = true;
					this.getPurchaseOrders();
					// this.resetFormPO()
					setTimeout(() => {
						this.formPurchaseOrderActive = false;
						this.newPurchaseOrderSaved = false;
					}, 1000);
				}).catch((err) => {
					//check if token fail
					if (err.response && err.response.status == 401) {
						localStorage.removeItem("accessToken");
						this.$router.push("/login");
					}
					console.log(err.response);
					this.errorPurchaseOrderList = [];
					this.errorPurchaseOrderList = Object.values(err.response.data.errors);
					console.log(this.errorPurchaseOrderList);
					this.savingNewPurchaseOrder = false;
					this.errorNewPurchaseOrder = true;
				});
			} else {
				this.savingNewPurchaseOrder = false;
				this.errorNewPurchaseOrder = true;
				this.errorPurchaseOrderList = [];
				if (this.newPurchaseOrder.no_po == "") {
					this.errorPurchaseOrderList.push(["- Mohon Isi No Purchase Order"]);
				}
				if (this.newPurchaseOrder.vendor_id == "") {
					this.errorPurchaseOrderList.push(["- Mohon Isi Nama Vendor"]);
				}
				if (this.newPurchaseOrder.date_po == "") {
					this.errorPurchaseOrderList.push(["- Mohon Isi Tanggal"]);
				}
				for (var x = 0; x < this.newPurchaseOrder.hardware.id.length; x++) {
					if (this.newPurchaseOrder.hardware.id[x] == "") {
						this.errorPurchaseOrderList.push(["- Mohon Pilih Hardware"]);
					}
					if (this.newPurchaseOrder.hardware.qty[x] == "" || this.newPurchaseOrder.hardware.qty[x] == "0") {
						this.errorPurchaseOrderList.push(["- Mohon Cantumkan Harga"]);
					}
				}
				console.log(this.newPurchaseOrder);
			}
		},
		// resetFormPO(){
		//     this.newPurchaseOrder.no_po=""
		//     this.newPurchaseOrder.date_po=""
		//     this.newPurchaseOrder.hardware.id=""

		// },
		deleteModalClose() {
			console.log("test");
		},
		deleteData() {
			this.deleteState = true;
			axios.delete(
				this.$baseUrl + "/api/pemesanan/purchaseorder/" + this.purchaseorders[this.selectedToDelete].id,
				{
					headers: {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
				}
			)
			     .then((result) => {
				     if (result.status == 200) {
					     this.purchaseorders.splice(this.selectedToDelete, 1);
					     this.deleted = true;
					     setTimeout(() => {
						     this.deleted = false;
					     }, 1000);

				     } else {
					     this.deleteFail = true;
				     }
				     this.deleteState = false;
			     }).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err.response);
				this.deleteState = false;
				this.deleteFail = true;
			});
		},
		deleteModalClose(mdl) {
			if (this.deleteState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-po");
			}
		},
		detailModalClose(mdl) {
			if (this.deleteState) {
				console.log("detail");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-detail-po");
			}
		},
		editModalClose(mdl) {
			//step 2 edit
			this.$set(this.purchaseorders, this.selectedIdforEdit, this.dataEdit);
			//step 3 edit
			this.dataEdit = Object.assign({}, null);
			if (this.updating) {
				console.log("detail");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-edit-po");
			}
		},
		moment(date) {
			return moment(date).format("ll");
		}

	}
};
</script>
<style scoped>
.dropdown-menu {
	display: none;
}

.btn {
	padding: 2px 6px;
}

::v-deep .modal-content {
	margin: -6.60rem auto;
}

table {
	border: 1px solid #ddd;
}

/*START CSS WINDOW CREATE VENDOR */
.btn-sm, .btn-group-sm > .btn {
	line-height: 0.5;
}

.btn-sm {
	padding: 5px;
}

/*END CSS WINDOW CREATE VENDOR */
.perangkat {
	text-align: left;
}

h4 {
	margin: 15px 0 15px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type=number] {
	-moz-appearance: textfield;
}
</style>
